var accordionData = {
  accordionContentCollection: {
    items: [{
      sys: {
        id: '0'
      },
      header: 'Lorem ipsum dolor',
      body: {
        json: {
          data: {},
          content: [{
            data: {},
            content: [{
              data: {},
              marks: [],
              value: 'Lorem ipsum dolor sit amet,magna.',
              nodeType: 'text'
            }],
            nodeType: 'paragraph'
          }, {
            data: {},
            content: [{
              data: {},
              marks: [],
              value: 'Maecenas mi urna, efficitur sit ametVestibulum ut magna metus.',
              nodeType: 'text'
            }],
            nodeType: 'paragraph'
          }],
          nodeType: 'document'
        }
      }
    }, {
      sys: {
        id: '1'
      },
      header: 'Lorem ipsum dolor',
      body: {
        json: {
          data: {},
          content: [{
            data: {},
            content: [{
              data: {},
              marks: [],
              value: 'Lorem ipsum dolor sit amet,magna.',
              nodeType: 'text'
            }],
            nodeType: 'paragraph'
          }, {
            data: {},
            content: [{
              data: {},
              marks: [],
              value: 'Maecenas mi urna, efficitur sit ametVestibulum ut magna metus.',
              nodeType: 'text'
            }],
            nodeType: 'paragraph'
          }],
          nodeType: 'document'
        }
      }
    }, {
      sys: {
        id: '2'
      },
      header: 'Lorem ipsum dolor',
      body: {
        json: {
          data: {},
          content: [{
            data: {},
            content: [{
              data: {},
              marks: [],
              value: 'Lorem ipsum dolor sit amet,magna.',
              nodeType: 'text'
            }],
            nodeType: 'paragraph'
          }, {
            data: {},
            content: [{
              data: {},
              marks: [],
              value: 'Maecenas mi urna, efficitur sit ametVestibulum ut magna metus.',
              nodeType: 'text'
            }],
            nodeType: 'paragraph'
          }],
          nodeType: 'document'
        }
      }
    }, {
      sys: {
        id: '3'
      },
      header: 'Lorem ipsum dolor',
      body: {
        json: {
          data: {},
          content: [{
            data: {},
            content: [{
              data: {},
              marks: [],
              value: 'Lorem ipsum dolor sit amet,magna.',
              nodeType: 'text'
            }],
            nodeType: 'paragraph'
          }, {
            data: {},
            content: [{
              data: {},
              marks: [],
              value: 'Maecenas mi urna, efficitur sit ametVestibulum ut magna metus.',
              nodeType: 'text'
            }],
            nodeType: 'paragraph'
          }],
          nodeType: 'document'
        }
      }
    }, {
      sys: {
        id: '4'
      },
      header: 'Lorem ipsum dolor',
      body: {
        json: {
          data: {},
          content: [{
            data: {},
            content: [{
              data: {},
              marks: [],
              value: 'Lorem ipsum dolor sit amet,magna.',
              nodeType: 'text'
            }],
            nodeType: 'paragraph'
          }, {
            data: {},
            content: [{
              data: {},
              marks: [],
              value: 'Maecenas mi urna, efficitur sit ametVestibulum ut magna metus.',
              nodeType: 'text'
            }],
            nodeType: 'paragraph'
          }],
          nodeType: 'document'
        }
      }
    }]
  }
};
var description = {
  json: {
    data: {},
    content: [{
      data: {},
      content: [{
        data: {},
        marks: [],
        value: 'Lorem ipsum dolor sit amet,magna.',
        nodeType: 'text'
      }],
      nodeType: 'paragraph'
    }, {
      data: {},
      content: [{
        data: {},
        marks: [],
        value: 'Maecenas mi urna, efficitur sit ametVestibulum ut magna metus.',
        nodeType: 'text'
      }],
      nodeType: 'paragraph'
    }],
    nodeType: 'document'
  }
};
var cta = {
  url: '#',
  label: 'CTA Label',
  behavior: 'local',
  hyperlinkType: 'anchor'
};
var accordionContentCollection = {
  items: [{
    sys: {
      id: '0'
    },
    header: 'Lorem ipsum dolor',
    body: {
      json: {
        data: {},
        content: [{
          data: {},
          content: [{
            data: {},
            marks: [],
            value: 'Lorem ipsum dolor sit amet,magna.',
            nodeType: 'text'
          }],
          nodeType: 'paragraph'
        }, {
          data: {},
          content: [{
            data: {},
            marks: [],
            value: 'Maecenas mi urna, efficitur sit ametVestibulum ut magna metus.',
            nodeType: 'text'
          }],
          nodeType: 'paragraph'
        }],
        nodeType: 'document'
      }
    }
  }, {
    sys: {
      id: '1'
    },
    header: 'Lorem ipsum dolor',
    body: {
      json: {
        data: {},
        content: [{
          data: {},
          content: [{
            data: {},
            marks: [],
            value: 'Lorem ipsum dolor sit amet,magna.',
            nodeType: 'text'
          }],
          nodeType: 'paragraph'
        }, {
          data: {},
          content: [{
            data: {},
            marks: [],
            value: 'Maecenas mi urna, efficitur sit ametVestibulum ut magna metus.',
            nodeType: 'text'
          }],
          nodeType: 'paragraph'
        }],
        nodeType: 'document'
      }
    }
  }, {
    sys: {
      id: '2'
    },
    header: 'Lorem ipsum dolor',
    body: {
      json: {
        data: {},
        content: [{
          data: {},
          content: [{
            data: {},
            marks: [],
            value: 'Lorem ipsum dolor sit amet,magna.',
            nodeType: 'text'
          }],
          nodeType: 'paragraph'
        }, {
          data: {},
          content: [{
            data: {},
            marks: [],
            value: 'Maecenas mi urna, efficitur sit ametVestibulum ut magna metus.',
            nodeType: 'text'
          }],
          nodeType: 'paragraph'
        }],
        nodeType: 'document'
      }
    }
  }, {
    sys: {
      id: '3'
    },
    header: 'Lorem ipsum dolor',
    body: {
      json: {
        data: {},
        content: [{
          data: {},
          content: [{
            data: {},
            marks: [],
            value: 'Lorem ipsum dolor sit amet,magna.',
            nodeType: 'text'
          }],
          nodeType: 'paragraph'
        }, {
          data: {},
          content: [{
            data: {},
            marks: [],
            value: 'Maecenas mi urna, efficitur sit ametVestibulum ut magna metus.',
            nodeType: 'text'
          }],
          nodeType: 'paragraph'
        }],
        nodeType: 'document'
      }
    }
  }, {
    sys: {
      id: '4'
    },
    header: 'Lorem ipsum dolor',
    body: {
      json: {
        data: {},
        content: [{
          data: {},
          content: [{
            data: {},
            marks: [],
            value: 'Lorem ipsum dolor sit amet,magna.',
            nodeType: 'text'
          }],
          nodeType: 'paragraph'
        }, {
          data: {},
          content: [{
            data: {},
            marks: [],
            value: 'Maecenas mi urna, efficitur sit ametVestibulum ut magna metus.',
            nodeType: 'text'
          }],
          nodeType: 'paragraph'
        }],
        nodeType: 'document'
      }
    }
  }]
};
var accordionMock1 = {
  sectionHeadline: 'Headline',
  description: description,
  cta: cta,
  fontColor: 'Dark',
  accordionContentCollection: accordionContentCollection
};
var accordionMock2 = {
  sectionHeadline: 'Headline',
  description: description,
  cta: cta,
  fontColor: 'Light',
  overrideBackground: {
    colorBackground: '#333'
  },
  accordionContentCollection: accordionContentCollection
};
var accordionMock3 = {
  accordionHeadline: 'Accordion Headline',
  accordionType: 'Multi-location-custom',
  description: {
    json: {
      data: {},
      content: [{
        data: {},
        content: [{
          data: {},
          marks: [],
          value: 'Lorem ipsum dolor sit amet,magna.',
          nodeType: 'text'
        }],
        nodeType: 'paragraph'
      }, {
        data: {},
        content: [{
          data: {},
          marks: [],
          value: 'Maecenas mi urna, efficitur sit ametVestibulum ut magna metus.',
          nodeType: 'text'
        }],
        nodeType: 'paragraph'
      }],
      nodeType: 'document'
    }
  },
  anchorLink: 'anchorLink',
  cta: {
    url: '#',
    label: 'CTA Label',
    behavior: 'local',
    hyperlinkType: 'anchor'
  },
  accordionContentCollection: {
    items: [{
      multiLocationContainer: {
        header: 'Location 222',
        yextIds: ['0100']
      }
    }]
  }
};
export { accordionData, accordionMock1, accordionMock2 };